export var TabsOverrides = function (theme) { return ({
    MuiTabs: {
        indicator: {
            height: '4px',
            backgroundColor: theme.palette.brand.main,
        },
        scrollButtons: {
            '& svg': {
                fontSize: '24px',
            },
        },
    },
}); };
//# sourceMappingURL=Tabs.overrides.js.map